import React from 'react';
import EditActivityFormBottomSection from '../editActivityForms/shared/EditActivityFormBottomSection';
import { ActivityFormCardLayout } from './ActivityFormCardLayout';
import { ActivityFormCardBaseProps } from './SharedActivityFormComponents';

interface EditActivityFormCardBaseProps extends ActivityFormCardBaseProps {
    showLastActivityInModuleWarning: boolean;
    showSavedSuccessfully: boolean;
    showSavedSuccessfullyEditMode: boolean;
    setDeleteAlertOpen: () => void;
    disableDeleteTaskButton: boolean;
    disableSubmitButton: boolean;
}

export function EditActivityFormCard(props: EditActivityFormCardBaseProps): JSX.Element {
    const {
        title,
        onSubmit,
        pageOne,
        pageTwo,
        submitting,
        error,
        showLastActivityInModuleWarning,
        showSavedSuccessfully,
        showSavedSuccessfullyEditMode,
        setDeleteAlertOpen,
        disableDeleteTaskButton,
        disableSubmitButton,
        activityType,
    } = props;

    return (
        <ActivityFormCardLayout
            title={title}
            onSubmit={onSubmit}
            pageOne={pageOne}
            pageTwo={pageTwo}
            activityType={activityType}
            renderBottomSection={({ fullWidth }) => (
                <EditActivityFormBottomSection
                    globalErrorMessage={error}
                    showLastActivityInModuleWarning={showLastActivityInModuleWarning}
                    showSavedSuccessfully={showSavedSuccessfully}
                    showSavedSuccessfullyEditMode={showSavedSuccessfullyEditMode}
                    setDeleteAlertOpen={setDeleteAlertOpen}
                    disableDeleteTaskButton={disableDeleteTaskButton}
                    disableSubmitButton={disableSubmitButton}
                    submitting={submitting}
                    fullWidth={fullWidth}
                    activityType={activityType}
                />
            )}
        />
    );
}
